import { Observable, Subject } from 'rxjs';

import { Component, ElementRef, Inject } from '@angular/core';

import { SnCurrentUser } from '@lib/auth/services';
import { GOOGLE_MAP_POPUP_DATA, GoogleMap } from '@lib/geo/google/map';
import { FsAxonDeviceAdvancedMarker } from '../axon-device-marker/axon-device-marker';

@Component({
  selector: 'fs-axon-device-popup',
  templateUrl: './axon-device-popup.component.html',
  styleUrls: ['./axon-device-popup.component.scss'],
})
export class AxonDevicePopupComponent {
  private readonly _dock$ = new Subject<void>();

  constructor(
    @Inject(GOOGLE_MAP_POPUP_DATA)
    public data: {
      marker: FsAxonDeviceAdvancedMarker;
      map: GoogleMap;
      openPopout: () => void;
      close: () => void;
    },
    public _currentUser: SnCurrentUser,
    public _element: ElementRef,
  ) {}

  get dock$(): Observable<void> {
    return this._dock$.asObservable();
  }

  public followMode(): void {
    this.data.marker.setFollowMode(true);
    this.openFeaturePopout();
  }

  public openFeaturePopout(): void {
    if (this.data.openPopout) {
      this.data?.openPopout();
      if (this.data?.close) {
        this.data.close();
      }
    }
  }

  public dock(): void {
    this._dock$.next();
    if (this.data?.close) {
      this.data.close();
    }
  }
}
